import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label"];
import React from 'react';
import { Select as BaseSelect, Option } from 'components/Select';
import useUniqueId from 'hooks/useUniqueId';
import VisuallyHidden from 'components/VisuallyHidden';
function Select(_ref) {
  var label = _ref.label,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var labelId = useUniqueId();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VisuallyHidden, {
    as: "label",
    id: labelId
  }, label), /*#__PURE__*/React.createElement(BaseSelect, _extends({
    fullWidth: true,
    size: "medium",
    variant: "transparent",
    textOverflow: "ellipsis",
    labelledById: labelId
  }, otherProps)));
}
export { Select, Option };